import request from '@/axios/bigData';

// 1获取事件类型列表
export const get_envent_enum = query => {
  return request({
    url: '/rpc/association_get_event_enum',
    method: 'GET',
    params: query
  });
};

// 2获取口径列表
export const get_cali_enum = query => {
  return request({
    url: '/rpc/association_get_cali_enum',
    method: 'GET',
    params: query
  });
};

// 3获取运算符
export const get_opt_enum = query => {
  return request({
    url: '/rpc/association_get_opt_enum',
    method: 'GET',
    params: query
  });
};

// 4获取事件属性列表
export const get_attr_enum_tmp = query => {
  return request({
    url: '/rpc/association_get_attr_enum',
    method: 'GET',
    params: query
  });
};

// 获取属性对应值列表
export const get_theme_attr_val = query => {
  return request({
    url: '/rpc/association_get_theme_attr_val',
    method: 'GET',
    params: query
  });
};

// 5获取某个事件属性的值列表
export const get_attr_val = query => {
  return request({
    url: '/rpc/association_get_attr_val',
    method: 'GET',
    params: query
  });
};

// 6获取分组列表
export const get_group_enum = query => {
  return request({
    url: '/rpc/association_get_group_enum',
    method: 'GET',
    params: query
  });
};

// 7获取时间周期列表
export const get_period_enum = query => {
  return request({
    url: '/rpc/association_get_period_enum',
    method: 'GET',
    params: query
  });
};

// 提交查询任务接口
export const get_association_job_submit_api = query => {
  return request({
    url: '/rpc/association_job_submit',
    method: 'GET',
    params: query
  });
};

// 查询任务结果接口
export const get_association_query_api = query => {
  return request({
    url: '/rpc/association_query',
    method: 'GET',
    params: query
  });
};
